import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import { FaHeart, FaStar, FaArrowAltCircleRight } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";

const Wishlist = () => {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

    const customerType = localStorage.getItem("CustomerType");
    const ledcode = localStorage.getItem("Ledcode");
    const ledname = localStorage.getItem("LedName");
    const ledemail = localStorage.getItem("LedEmail");

    const [wishlist, setWishlist] = useState([]);

    // const [products, setProducts] = useState([]);
    const navigate = useNavigate();

    // useEffect(() => {
    //     const fetchProducts = async () => {
    //         try {
    //             const response = await axios.get(`${apiBaseUrl}/getProductByCategory/JAPAN_ACCESORIES?Id=691`);
    //             setProducts(response.data.slice(0, 8));
    //         } catch (error) {
    //             console.error("Error fetching products:", error);
    //         }
    //     };

    //     fetchProducts();
    // }, [apiBaseUrl]);

    const fullimage = (itemId, ID, customerType) => {
        navigate(`/fullimage/${itemId}/${ID}/${customerType}`);
    };

    const renderPriceInfo = (product) => {
        // if (!customerType) {
        return <span id="h3">MRP: ₹ {product.MRP}</span>;
    };

    //     switch (customerType) {
    //         case "CUSTOMER":
    //             return (
    //                 <div>
    //                     {/* <div id="h3">MOP: ₹ {product.MOP}</div>
    //                     <div id="h3">MRP: ₹ {product.MRP}</div> */}
    //                     <div id="h3">₹ {product.MOP}</div>
    //                 </div>
    //             );
    //         case "AGENT":
    //             return (
    //                 <div>
    //                     <div id="h3">AP: ₹ {product.AP}</div>
    //                     <div id="h3">MOP: ₹ {product.MOP}</div>
    //                     <div id="h3">MRP: ₹ {product.MRP}</div>
    //                 </div>
    //             );
    //         case "DEALER":
    //             // return <span id="h3">DP: ₹ {product.DP}</span>;
    //             return (
    //                 <div>
    //                     <div id="h3">DP: ₹ {product.DP}</div>
    //                     <div id="h3">MOP: ₹ {product.MOP}</div>
    //                     <div id="h3">MRP: ₹ {product.MRP}</div>
    //                 </div>
    //             );
    //         case "JS_EMPLOYEE":
    //         case "TK_EMPLOYEE":
    //             return (
    //                 <div>
    //                     <div id="h3">Branch: {product.Branch}</div>
    //                     <div id="h3">MRP: ₹ {product.MRP}</div>
    //                 </div>
    //             );
    //         case "JS_MANAGER":
    //         case "TK_MANAGER":
    //             return (
    //                 <div>
    //                     <div id="h3">Rate: ₹{product.RealPrateTax}</div>
    //                     <div id="h3">MRP: ₹ {product.MRP}</div>
    //                 </div>
    //             );
    //         default:
    //             return (
    //                 <div>
    //                     {/* <span id="h3">MOP: ₹ {product.MOP}</span>
    //                     &nbsp;&nbsp;&nbsp;&nbsp; */}
    //                     <div id="h3">MRP: ₹ {product.MRP}</div>
    //                 </div>
    //             );
    //     }
    // };

    useEffect(() => {
        const fetchWishlist = async () => {
            const ledcode = localStorage.getItem("Ledcode");
            try {
                const res = await axios.get(`${apiBaseUrl}/wishlist/items/JAPAN_ACCESORIES/${ledcode}`);

                if (res.data.success && Array.isArray(res.data.items)) {
                    setWishlist(res.data.items);
                }
            } catch (err) {
                console.error("Fetch wishlist error:", err);
            }
        };

        fetchWishlist();
    }, [apiBaseUrl]);

    const removeFromWishlist = async (productId) => {
        try {
            const res = await axios.delete(`${apiBaseUrl}/wishlist/delete/JAPAN_ACCESORIES/${productId}`);

            if (res.data.success) {
                // Remove from local state
                setWishlist((prev) => prev.filter((item) => item.ID !== productId));
                toast.success("Removed from wishlist!");
            } else {
                toast.error("Failed to remove from wishlist");
            }
        } catch (error) {
            console.error("Wishlist remove error:", error);
            toast.error("Error removing from wishlist");
        }
    };

    const [quantities, setQuantities] = useState({});
    const [selectedVariant, setSelectedVariant] = useState("");

    const handleAddToCart = (productId) => {
        console.log(productId);
        const product = wishlist.find((p) => p.ID === productId);
        console.log(product);

        if (!product) {
            console.error("❌ Product not found for ID:", productId);
            toast.error("Product not found. Please refresh the page.");
            return;
        }

        addToCart(product);
    };

    const addToCart = async (product) => {
        const quantity = quantities[product.ID];

        if (quantity === "" || !/^\d+$/.test(quantity) || Number(quantity) <= 0) {
            toast.error("Please enter a valid quantity");
            return;
        }

        const qtyNumber = Number(quantity);
        const existingData = JSON.parse(localStorage.getItem("productData")) || [];

        // const index = existingData.findIndex((item) => item.id === product.ID);
        const index = existingData.findIndex((item) => item.id === product.ID && item.selectedVariant === selectedVariant);

        let quantityDifference = qtyNumber;
        let uniqueCode = generateUniqueCode();
        // let uniqueCode = "0";

        if (index !== -1) {
            const updatedQuantity = existingData[index].quantity + qtyNumber;
            if (updatedQuantity > product.Qty) {
                toast.error(`Total quantity exceeds stock (${product.Qty})`);
                return;
            }

            // Keep old code
            uniqueCode = existingData[index].uniqueCode;

            existingData[index].quantity = updatedQuantity;
        } else {
            if (qtyNumber > product.Qty) {
                toast.error(`Available stock is ${product.Qty}`);
                return;
            }

            existingData.push({
                itemName: product.ItemName,
                id: product.ID,
                mop: product.MOP,
                dp: product.DP,
                ap: product.AP,
                mrp: product.MRP,
                branch: product.Branch,
                realpratetax: product.RealPrateTax,
                quantity: qtyNumber,
                uniqueCode,
                selectedVariant, // Track variant in local storage
            });
        }

        // Save to localStorage
        localStorage.setItem("productData", JSON.stringify(existingData));

        const price = getNumericPrice(product);

        // Send to API
        try {
            const payload = {
                itemId: product.ID,
                uniqueCode, // Use the correct one
                itemName: product.ItemName,
                itemPrice: price,
                quantity: quantityDifference,
                ledname,
                ledcode,
                ledemail: ledemail || "no email",
            };
            console.log("Payload to API:", payload);

            const res = await axios.post(`${apiBaseUrl}/cart/add/JAPAN_ACCESORIES`, payload);

            console.log("API Response:", res.data);

            if (res.data.success) {
                toast.success("Item added to cart");
            } else {
                toast.error("Failed to sync with server");
            }
        } catch (err) {
            // console.error("Add to cart error:", err);
            // toast.error("Server error: unable to sync cart");
            console.error("Add to cart error:", err?.response?.data || err.message || err);
            toast.error("Server error: unable to sync cart");
        }

        setQuantities((prev) => ({ ...prev, [product.ID]: "" }));
    };

    const generateUniqueCode = () => {
        return (
            Date.now().toString(36) + // Timestamp in base36
            Math.random().toString(36).substring(2, 8).toUpperCase() // Random 6 chars
        );
    };

    const getNumericPrice = (product) => {
        switch (customerType) {
            case "CUSTOMER":
                return product.MOP ?? product.MRP;
            case "AGENT":
                return product.AP ?? product.MRP;
            case "DEALER":
                return product.DP ?? product.MRP;
            case "JS_EMPLOYEE":
            case "TK_EMPLOYEE":
            case "JS_MANAGER":
            case "TK_MANAGER":
                return product.MRP;
            default:
                return product.MRP;
        }
    };

    const handleQuantityChange = (productId, value) => {
        setQuantities((prev) => ({
            ...prev,
            [productId]: value,
        }));
    };

    return (
        <div className="min-h-screen flex flex-col bg-[#F7F7F7] flex-1 pb-5 ">
            {/* Navbar */}
            <div className="sticky top-0 z-50">
                <Navbar />
            </div>

            {/* Header */}
            <div className="w-full bg-gradient-to-r from-[#8b0000] to-red-600 py-5 text-white text-center">
                <h1 className="text-4xl font-bold mb-2">Wish List</h1>
                <p className="text-lg">Add to your cart to checkout</p>
            </div>

            {wishlist.length === 0 ? (
                <div className="width-full flex justify-center items-center h-[10vh]">
                    <span className="text-xl font-[500] font-display text-[#c61c1c]">Wish List is Empty</span>
                </div>
            ) : (
                <div className="w-full px-4 sm:px-28 py-6 ">
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 w-full mt-5">
                        {wishlist.map((product, index) => (
                            <div
                                key={product.ID}
                                className="product-card w-full flex flex-col rounded-md border-[#d1d5db] shadow-xl bg-[white] my-2"
                            >
                                <div
                                    // onClick={() => fullimage(product.ItemName, product.ID, customerType)}
                                    className="relative group w-full lg:h-[313px] md:h-[270px] sm:h-[250px] h-[200px] flex flex-col justify-center items-center bg-[white] rounded-[10px] gap-[2%] cursor-pointer overflow-hidden"
                                >
                                    <button
                                        onClick={() => removeFromWishlist(product.ID, ledcode)}
                                        className="absolute top-3 right-3 hover:text-[#d1d5db] text-[red]"
                                    >
                                        <MdDeleteForever size={20} />
                                    </button>
                                    <div
                                        onClick={() => fullimage(product.ItemName, product.ID, customerType)}
                                        className="w-[68%] h-[68%] flex justify-center items-center "
                                    >
                                        <img
                                            src={`${apiLocalUrl}/uploads/${product.ID}.jpg?v=${Date.now()}`}
                                            alt="carcharger"
                                            className="size-[100%] object-contain mix-blend-multiply"
                                        />
                                    </div>

                                    {/* Add to Cart Button*/}
                                    <div className=" w-full text-center">
                                        <div className="mx-4 bg-gradient-to-r from-[#8b0000] to-[#d78e8e] rounded text-[white] p-2 flex items-center justify-center">
                                            <div className="flex">
                                                <span className="text-lg font-medium">🛒</span>
                                                <span className=" hidden md:flex lg:text-md sm:text-sm text-xs font-medium items-center">
                                                    Add to Cart
                                                </span>
                                            </div>

                                            <input
                                                type="text"
                                                min="1"
                                                value={quantities[product.ID] || ""}
                                                onChange={(e) => handleQuantityChange(product.ID, e.target.value)}
                                                // onBlur={() => handleBlur(product.ID)}
                                                className="md:w-12 w-10 px-1 py-0.5 text-[black] rounded  mx-1 lg:text-md sm:text-sm text-xs font-medium"
                                            />
                                            <span
                                                role="button"
                                                onClick={() => handleAddToCart(product.ID)}
                                                className="cursor-pointer hover:underline"
                                            >
                                                <FaArrowAltCircleRight className="md:size-6 size-5" />
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    onClick={() => fullimage(product.ItemName, product.ID, customerType)}
                                    className="w-full md:h-[25vh] h-auto flex flex-col items-start py-2 gap-1 px-4 rounded-b-[10px] bg-[white]"
                                >
                                    <p className="text-sm text-[#a4a7ab] mb-1">Category</p>
                                    <span className="lg:text-md sm:text-sm text-xs font-medium text-left w-[70%]">
                                        {product.ItemName}
                                    </span>
                                    {/* Rating */}
                                    {/* <div className="flex gap-1 ">
                                        {[...Array(5)].map((_, i) => (
                                            <FaStar key={i} className="text-[#FACC15] text-sm" />
                                        ))}
                                    </div> */}

                                    <div className="flex flex-row justify-between items-center w-full gap-2">
                                        <span className="lg:text-md sm:text-sm text-xs text-[#2563EB] font-semibold text-left w-full">
                                            {renderPriceInfo(product)}
                                        </span>
                                        <span className="text-[#d1d5db] text-sm">₹</span>
                                        <span className="text-[#d1d5db] line-through text-sm">{product.MRP}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {/* Footer */}
            <div className="mt-auto bg-[white]">
                <Footer />
            </div>
            <ToastContainer autoClose={1500} />
        </div>
    );
};

export default Wishlist;
